/**
 * ch_util
 *
 * "A big mess of globals and polyfills"
 */
define('ch_utils',[],function () {
    String.prototype.toCamel = function () {
        return this.replace(/(\-[a-z])/g, function ($1) { return $1.toUpperCase().replace('-', ''); });
    };

    String.prototype.toDash = function () {
        return this.replace(/([A-Z])/g, function ($1) { return '-' + $1.toLowerCase(); });
    };

    String.prototype.toUnderscore = function () {
        return this.replace(/([A-Z])/g, function ($1) { return '_' + $1.toLowerCase(); });
    };

    String.prototype.toHuman = function () {
        return this.replace(/[_\]\[]/g, ' ').trim().replace(/(?:^|\s)\w/g, function (match) {
            return match.toUpperCase();
        });
    };

    String.prototype.upperCaseFirstChar = function () {
        return this.charAt(0).toUpperCase() + this.slice(1);
    };

    window.preg_quote = function (str, delimiter) {
        return String(str).replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\' + (delimiter || '') + '-]', 'g'), '\\$&');
    };

    // Generates prices in right format
    window.formatPrice = function (value, stripTrailingZeros = false) {
        return formatToUSD(value, { stripTrailingZeros });
    };

    window.pluralize = function (singular, plural, count) {
        return count == 1 ? singular : plural;
    };

    // Text-Area character counter
    //
    // Deliberately jQuery-free: this file ships in every webpack bundle, and a bare `$` here
    // made webpack's ProvidePlugin pull all of jQuery into the homepage bundle for this one
    // call. Callers (semantic_external_provider_review_page.js, a legacy page) pass jQuery
    // objects or DOM nodes; unwrap instead of wrapping.
    window.characterCounter = function (formElement, maxCount, charactersRemainingElement) {
        var field = formElement && formElement.jquery ? formElement[0]
            : typeof formElement === 'string' ? document.querySelector(formElement)
            : formElement;
        var target = charactersRemainingElement && charactersRemainingElement.jquery
            ? charactersRemainingElement[0]
            : charactersRemainingElement;

        var charsLength = field && typeof field.value === 'string' ? field.value.length : 0;
        var charsRemaining = maxCount - charsLength;
        var remainingString = ' characters remaining.';
        if (charsRemaining == 1) {
            remainingString = ' character remaining... make it count!';
        }
        var str = charsRemaining >= 0 ? charsRemaining + remainingString : 'Your message is too long!';

        if (target) {
            target.innerHTML = str;
        }
    };

    /**
     * numberFormat
     *
     * Formats a number with commas similar to PHP's number_format function
     *
     * @param   numStr      a number or numeric string
     * @returns string      number with commas
     */
    window.numberFormat = function (numStr) {
        var x; var x1; var x2; var
            rgx;

        // convert to string
        numStr += '';

        x = numStr.split('.');
        x1 = x[0];
        x2 = x.length > 1 ? '.' + x[1] : '';
        rgx = /(\d+)(\d{3})/;

        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }

        return x1 + x2;
    };

    /**
     * updateQueryStringParameter
     *
     * add or update the value of a URL query string parameter
     *
     * @source  http://stackoverflow.com/questions/5999118/add-or-update-query-string-parameter
     * @param   string  uri     the uri string
     * @param   string  key     the parameter to affect
     * @param   mixed   value   the value to set
     * @returns string          the uri string with query parameter set
     */
    window.updateQueryStringParameter = function (uri, key, value) {
        var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
        var separator = uri.indexOf('?') !== -1 ? '&' : '?';
        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + '=' + value + '$2');
        }
        return uri + separator + key + '=' + value;
    };

    /**
     * parseURI 1.2.2
     *
     * Parse a URI string into an object of URI properties.
     *
     * (c) Steven Levithan <stevenlevithan.com>
     * MIT License
     *
     * @param str
     * @returns {{}}
     */
    window.parseUri = function (str) {
        var o = parseUri.options;
        var m = o.parser[o.strictMode ? 'strict' : 'loose'].exec(str);
        var uri = {};
        var i = 14;

        while (i--) uri[o.key[i]] = m[i] || '';

        uri[o.q.name] = {};
        uri[o.key[12]].replace(o.q.parser, function ($0, $1, $2) {
            if ($1) uri[o.q.name][$1] = $2;
        });

        return uri;
    };

    parseUri.options = {
        strictMode: false,
        key: [
            'source',
            'protocol',
            'authority',
            'userInfo',
            'user',
            'password',
            'host',
            'port',
            'relative',
            'path',
            'directory',
            'file',
            'query',
            'anchor',
        ],
        q: {
            name: 'queryKey',
            parser: /(?:^|&)([^&=]*)=?([^&]*)/g,
        },
        parser: {
            strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
            loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/,
        },
    };

    // these are the newer utils
    // above this are the old

    function addListenersToCollection(collection, eventType, fn) {
        return collection.forEach((el) => {
            el.addEventListener(eventType, fn);
        });
    }

    function getElements(queryString) {
        return document.querySelectorAll(queryString);
    }

    function getElementsAndAddListener(queryString, eventType, fn) {
        return addListenersToCollection(
            getElements(queryString),
            eventType,
            fn
        );
    }

    function formatToUSD(value, options) {
        const defaultOptions = {
            stripTrailingZeros: true
        }

        // Spread operator (...) throws an error in r.js... >_<
        const appliedOptions = Object.assign(defaultOptions, options)

        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });

        if (appliedOptions.stripTrailingZeros) {
            return stripTrailingZerosFromUSD(formatter.format(value));
        }

        return formatter.format(value);
    }

    function usdToFloat(str) {
        return parseFloat(str.replace(/[^0-9.]/g, ''));
    }

    function stripTrailingZerosFromUSD(usdString) {
        return usdString.trim().replace(/\.00$/, '');
    }

    function debounce(func, delay) {
        let timeoutId;
        return function () {
            const context = this;
            const args = arguments;
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func.apply(context, args);
            }, delay);
        };
    }

    function waitForAddedNode(params) {
        // The node may already be in the DOM before the observer starts
        const existing = document.querySelector(params.selector);
        if (existing) {
            params.done(existing);
            return;
        }

        new MutationObserver(function () {
            const el = document.querySelector(params.selector);
            if (el) {
                this.disconnect();
                params.done(el);
            }
        }).observe(params.parent || document, {
            subtree: !!params.recursive || !params.parent,
            childList: true,
        });
    };

    // Works like PHP's round(value, precision, mode) with mode set to PHP_ROUND_HALF_DOWN
    function roundHalfDown(value, precision = 0) {
        const factor = Math.pow(10, precision);

        return -Math.round(-1 * value * factor) / factor
    }

    function charsRemainingMessage(charCount, maxCharCount) {
        const remaining = maxCharCount - charCount

        let message = `${remaining} characters remaining.`

        if (remaining == 1) {
            message = `${message}.. make it count!`;
        }

        if (remaining < 0) {
            message = 'Your message is too long!'
        }

        return message
    }

    /**
     * Lazy loads a script when a target element enters the viewport
     *
     * @param {string} scriptSrc - The URL of the script to load
     * @param {Object} scriptAttributes - Key-value pairs of script attributes (e.g., {type: 'module'})
     * @param {string} targetSelector - CSS selector for the element that triggers loading when visible
     * @param {Object} options - Additional options for the loader
     * @param {string} [options.rootMargin='200px 0px'] - Root margin for IntersectionObserver
     * @param {number} [options.threshold=0] - Threshold for IntersectionObserver
     * @param {Function} [options.onLoad] - Callback function executed after script loads successfully
     * @returns {Promise} - Resolves when the script is loaded
     */
    function lazyLoadScript(scriptSrc, scriptAttributes = {}, targetSelector, options = {}) {
        return new Promise((resolve, reject) => {
            // Check if script is already loaded
            const existingScript = document.querySelector(`script[src="${scriptSrc}"]`);
            if (existingScript) {
                if (options.onLoad && typeof options.onLoad === 'function') {
                    options.onLoad(existingScript);
                }
                resolve(existingScript);
                return;
            }

            const target = document.querySelector(targetSelector);

            if (!target) {
                console.warn(`Target element ${targetSelector} not found. Loading script immediately.`);
                loadScript().then(script => {
                    if (options.onLoad && typeof options.onLoad === 'function') {
                        options.onLoad(script);
                    }
                    resolve(script);
                }).catch(reject);
                return;
            }

            const observerOptions = {
                rootMargin: options.rootMargin || '200px 0px',
                threshold: options.threshold || 0
            };

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        loadScript().then(script => {
                            if (options.onLoad && typeof options.onLoad === 'function') {
                                options.onLoad(script);
                            }
                            resolve(script);
                        }).catch(reject);
                        observer.disconnect();
                    }
                });
            }, observerOptions);

            observer.observe(target);

            function loadScript() {
                return new Promise((resolve, reject) => {
                    const script = document.createElement('script');
                    script.src = scriptSrc;

                    // Apply all script attributes
                    Object.entries(scriptAttributes).forEach(([key, value]) => {
                        if (value === true) {
                            script[key] = true;
                        } else if (value !== false && value !== null && value !== undefined) {
                            script.setAttribute(key, value);
                        }
                    });

                    script.onload = () => resolve(script);
                    script.onerror = () => reject(new Error(`Failed to load script: ${scriptSrc}`));

                    document.head.appendChild(script);
                });
            }
        });
    }


    return {
        getElementsAndAddListener,
        getElements,
        addListenersToCollection,
        formatToUSD,
        usdToFloat,
        stripTrailingZerosFromUSD,
        debounce,
        waitForAddedNode,
        roundHalfDown,
        charsRemainingMessage,
        lazyLoadScript
    };
});

